@if (dataContext) {
  <form class="amortization-plan-document-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4>{{ 'LEASE_AGREEMENT_DOCUMENT.FORM_HEADER' | translate }}</h4>
    <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
      <app-single-file-upload (filesSelected)="onFileChange($event)"></app-single-file-upload>
      <astral-input [control]="form.controls['caption']"></astral-input>
    </section>
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" label="OK"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
